import builder from '../builder';
import ImageFilePNG from '../../streamline-icons/bold/image-file-png-1.svg';

export default builder('ImageFilePNGBold', ImageFilePNG);
